
@if (!AccessAllowed && CompletedLoading) {
  <div>
    <h3 style="border: 2px solid;border-radius: 6px;position: absolute;top: 50%;left: 50%;transform: translate(-50%, -50%);padding: 10px;">You don't have access to this function</h3>
  </div>
}

@if (pageReady && AccessAllowed) {
  <div class="p-3 flex flex-column flex-auto">
    <div>
      <div class="text-900 font-medium text-xl mb-3"><h3>Resource Adjustment</h3></div>
      <p class="m-0 mb-4 p-0 text-600 line-height-3 mr-3">
        <span class="pi pi-info-circle" style="margin-right:2px;"></span>
        Resource Adjustments allow you to temporarily change the capacity of a resource for a period - either set a new capacity, higher or lower, or reduce it by an amount.
      </p>
      <div class="surface-card p-4 shadow-2 border-round">
        <div class="grid formgrid p-fluid">
          <div class="field mb-4 col-12">
            <label for="Resourcereductionname" class="font-medium">Resource Adjustment Name</label>
            <input [(ngModel)]="ResourceReduction.name"  id="Resourcereductionname" type="text" required (keyup)="DoValidCheck()" pInputText>
            @if (!resourceNameValid) {
              <div class="text-danger" Style="margin-left:10px; margin-top: 0px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a Resource Adjustment name.</div>
            }
            @if (!resourceDateLoginValid) {
              <div class="text-danger" Style="margin-left:10px; margin-top: 0px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>The Start Date must be before the End Date.</div>
            }
          </div>
          <div class="field mb-4 col-12">
            <label for="resource" class="font-medium">Resource to adjust</label>
            <p-select optionLabel="name" optionvalue="id" placeholder="Select a Resource" [options]="ResourceList" [(ngModel)]="chosenResource" (onChange)="onResourceChange()"></p-select>
            @if (!resourceChosenValid) {
              <div class="text-danger" Style="margin-left:10px; margin-top: 0px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must select a resource.</div>
            }
          </div>
          <div style="clear:both;"></div>
          <div class="field mb-4 col-12">
            <label for="adjustmenttype" class="font-medium">Adjustment Type</label><br>
            <p-selectbutton id="adjustmenttype" [options]="adjustmentTypeOptions" [(ngModel)]="ResourceReduction.adjustmenttype" (onChange)="onAdjustmentTypeChange()"></p-selectbutton>
          </div>
          <div class="field mb-4 col-12" style="max-width: 500px;">
            <label for="adjustmentamount" class="font-medium">{{ResourceReduction.adjustmenttype == 'NEWCAPACITY' ? 'New Capacity' : 'Reduce Capacity By'}}</label>
            <p-inputnumber inputId="adjustmentamount" [showButtons]="true" [max]="adjustmentMax()" min="0" [(ngModel)]="ResourceReduction.adjustmentamount" [disabled]="!chosenResource?.resourceId" buttonLayout="horizontal" spinnerMode="horizontal"></p-inputnumber>
            @if (chosenResource?.resourceId && ResourceReduction.adjustmenttype == 'REDUCEBY') {
              <small class="block mt-1" style="color:#6c757d;">New capacity will be {{resultingCapacity()}} (currently {{resourceCapacity}}).</small>
            }
            @if (chosenResource?.resourceId && ResourceReduction.adjustmenttype == 'NEWCAPACITY') {
              <small class="block mt-1" style="color:#6c757d;">Currently {{resourceCapacity}}. This can be set higher or lower than now.</small>
            }
            @if (!chosenResource?.resourceId) {
              <small class="block mt-1" style="color:#6c757d;">Choose a resource first.</small>
            }
            @if (!adjustmentValid) {
              <div class="text-danger" Style="margin-left:10px; margin-top: 0px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>The amount must be between 0 and {{adjustmentMax()}}.</div>
            }
          </div>
          <div style="clear:both;"></div>
          <div class="field mb-4 col-12">
            <label for="reductionbasedonday" class="font-medium">Adjustment Based on Day</label><br>
            <p-selectbutton id="reductionbasedonday" [style]="{'width': '150px'}" [options]="stateOptions" [(ngModel)]="ResourceReduction.reductionbasedonday" (onChange)="DoValidCheck()"></p-selectbutton>
          </div>
          @if (ResourceReduction.reductionbasedonday) {
            <div class="field mb-4 col-12">
              <label class="font-medium">Days Adjusted</label><br>
              <div style="display:flex; gap:8px; flex-wrap:wrap;">
                @for (day of dayOptions; track day) {
                  <button pButton type="button"
                    style="width:auto; flex:0 0 auto; padding-left:14px; padding-right:14px;"
                    [ngClass]="selectedDays.includes(day.value) ? 'p-button p-button-primary p-button-sm' : 'p-button p-button-outlined p-button-secondary p-button-sm'"
                  (click)="toggleDay(day.value)">{{ day.label }}</button>
                }
              </div>
              @if (!resourceDaysValid) {
                <div class="text-danger" Style="margin-left:10px; margin-top: 0px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must select at least one day.</div>
              }
            </div>
          }
          <div style="clear:both;"></div>
          <!-- Dates and times apply whether or not the adjustment is day based: the days say
          which days it falls on, these say the period it runs over and the hours. -->
          <div style="width:100%;">
            <div class="field mb-4 col-12" style="max-width: 500px;">
              <label for="Resourcereductionstartdate">Resource Adjustment Start Date</label>
              <p-datepicker [selectOtherMonths]="true" [(ngModel)]="newStartDate" firstDayOfWeek="1" dateFormat="dd/mm/yy" (onSelect)="DoDateValidCheck(); DoDateCheck();" [showIcon]="true" inputId="Resourcereductionstartdate"></p-datepicker>
              @if (!resourceStartDateValid) {
                <div class="text-danger" Style="margin-left:10px; margin-top: 0px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter a Start Date.</div>
              }
            </div>
            <div class="field mb-4 col-12" style="max-width: 500px;">
              <label for="Resourcereductionstarttime">Resource Adjustment Start Time</label>
              <br>
                <p-select [options]="resourceStartTimeHours" [style]="{'width': '95px', 'float': 'left'}"  [(ngModel)]="resourceSelectedStartTimeHours" optionValue="code" optionLabel="name"></p-select>
                <span style="font-size: 29px;float: left;margin-left: 10px;margin-right: 10px;">:</span>
                <p-select [options]="resourceStartTimeMins" [style]="{'width': '95px', 'float': 'left'}"  [(ngModel)]="resourceSelectedStartTimeMins" optionValue="code" optionLabel="name"></p-select>
                <div style="clear:both;"></div>
              </div>
              <div class="field mb-4 col-12" style="max-width: 500px;">
                <label for="Resourcereductionenddate">Resource Adjustment End Date</label>
                <p-datepicker [selectOtherMonths]="true" [(ngModel)]="newEndDate" firstDayOfWeek="1" dateFormat="dd/mm/yy" (onSelect)="DoDateValidCheck(); DoDateCheck();" [showIcon]="true" inputId="Resourcereductionenddate"></p-datepicker>
                @if (!resourceEndDateValid) {
                  <div class="text-danger" Style="margin-left:10px; margin-top: 0px;"><span class="pi pi-exclamation-triangle" style="margin-right:5px;"></span>You must enter an End Date.</div>
                }
              </div>
              <div class="field mb-4 col-12" style="max-width: 500px;">
                <label for="Resourcereductionendtime">Resource Adjustment End Time</label>
                <br>
                  <p-select [options]="resourceStartTimeHours" [style]="{'width': '95px', 'float': 'left'}"  [(ngModel)]="resourceSelectedEndTimeHours" optionValue="code" optionLabel="name"></p-select>
                  <span style="font-size: 29px;float: left;margin-left: 10px;margin-right: 10px;">:</span>
                  <p-select [options]="resourceStartTimeMins" [style]="{'width': '95px', 'float': 'left'}"  [(ngModel)]="resourceSelectedEndTimeMins" optionValue="code" optionLabel="name"></p-select>
                  <div style="clear:both;"></div>
                </div>
              </div>
              <div style="clear:both;"></div>
              <p>The message fields allow you to pop up a message when someone selects a date which falls on a Resource Adjustment.</p>
              <div class="field mb-4 col-12">
                <label for="reductionpublicmessage" class="font-medium">Public Message</label>
                <textarea id="reductionpublicmessage" [(ngModel)]="ResourceReduction.publicmessage" (keyup)="DoValidCheck()" [rows]="5" [cols]="50" pTextarea autoResize="autoResize"></textarea>
              </div>
              <div class="field mb-4 col-12">
                <label for="reductionvenuemessage" class="font-medium">Venue Message</label>
                <textarea id="reductionvenuemessage" [(ngModel)]="ResourceReduction.venuemessage" (keyup)="DoValidCheck()" [rows]="5" [cols]="50" pTextarea autoResize="autoResize"></textarea>
              </div>
              <div class="col-12">
                <button pButton pRipple type="button" class="p-button p-element p-button-success w-auto mt-3" (click)="updateData();">
                  <span class="pi pi-pencil" style="margin-right:8px;"></span>
                Save Changes</button>
                &nbsp;
                <button pButton pRipple type="button" class="p-button p-element p-button-danger w-auto mt-3" (click)="returnToList()">
                  <span class="pi pi-times" style="margin-right:8px;"></span>
                Cancel</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
